import { Nav } from "@douyinfe/semi-ui";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";

const ContactFooter = () => {
  const { t } = useTranslation();

  return (
    <Nav mode={"horizontal"} className={styles.container}>
      <Nav.Header>
        <div className={`semi-navigation-list`} style={{ marginLeft: "-12px" }}>
          <Nav.Item
            link="https://www.biogeom.com"
            linkOptions={{
              target: "_blank",
              title: "© 2022-2025 BioGeometry",
            }}
            className={styles.link}
            text="© 2022-2025 BioGeometry"
          />
        </div>
      </Nav.Header>
      <a
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        rel="noreferrer"
        className={styles.outerLink}
      >
        京ICP备2022032231号-2
      </a>
      &nbsp;|&nbsp;
      <a
        rel="noreferrer"
        href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802045658"
        target="_blank"
        className={styles.outerLink}
      >
        京公网安备11010802045658号
      </a>
      <Nav.Footer collapseButton={true}>
        <div className="semi-navigation-list" style={{ marginRight: "-12px" }}>
          <Nav.Item
            className={styles.link}
            link="/terms"
            text={t("footer.term")}
          />
        </div>
      </Nav.Footer>
    </Nav>
  );
};

export default ContactFooter;
